import React, { useEffect, useState } from "react";
import { formatTime } from "utils/util";
import { togglePostLike } from "api/community";
import { stripMentionsToText } from "utils/mention";
import CmsPreviewShell from "./CmsPreviewShell";
import {getTop5Posting} from 'api/mainTab'
import "assets/scss/components/hotPostCarousel.scss";

const PostCardMedia = ({ mediaType, mediaUrls }) => {
  
  if (mediaType === "video" && mediaUrls && mediaUrls.length > 0) {
    return (
      <div className="hpc-card-media hpc-card-media--video">
        <video src={mediaUrls[0]} alt="" loading="lazy" decoding="async" />
        <div className="hpc-video-play-icon">
          <svg viewBox="0 0 16 16" fill="white">
            <path d="M5 3.5v9L13 8 5 3.5z" />
          </svg>
        </div>
      </div>
    );
  }

  if (mediaType  && mediaUrls && mediaUrls.length > 0) {
    if (mediaUrls.length === 1) {
      return (
        <div className="hpc-card-media">
          <img src={mediaUrls[0]} alt="" loading="lazy" decoding="async" />
        </div>
      );
    }
    if (mediaUrls.length === 2) {
      return (
        <div className="hpc-card-media hpc-card-media--duo">
          <img src={mediaUrls[0]} alt="" loading="lazy" decoding="async" />
          <img src={mediaUrls[1]} alt="" loading="lazy" decoding="async" />
        </div>
      );
    }
    // 3장 이상
    const extra = mediaUrls.length - 3;
    return (
      <div className="hpc-card-media hpc-card-media--trio">
        <div className="hpc-thumb-main">
          <img src={mediaUrls[0]} alt="" loading="lazy" decoding="async" />
        </div>
        <div>
          <img src={mediaUrls[1]} alt="" loading="lazy" decoding="async" />
        </div>
        <div className="hpc-thumb-more">
          <img src={mediaUrls[2]} alt="" loading="lazy" decoding="async" />
          {extra > 0 && <div className="hpc-more-overlay">+{extra}</div>}
        </div>
      </div>
    );
  }

  // 미디어 없음
  return (
    <></>
  );
};

const getOptimisticLikedPost = (post) => {
  const isLiked = !!post.is_liked;
  const likeCount = post.like_count ?? 0;

  return {
    ...post,
    is_liked: !isLiked,
    like_count: Math.max(likeCount + (isLiked ? -1 : 1), 0),
  };
};





const CommunityComponent = ({ title, subtitle, layout, items = [] }) => {
  const [top5Posting, setTop5Posting] = useState([])

  useEffect(()=>{
    getTop5Posting()
    .then(res => {
      setTop5Posting(res.data)
    })
  },[])

  return (
    <CmsPreviewShell title={top5Posting.length > 0 ? title : null} subtitle={subtitle}>
      <div className={`cms-gallery cms-gallery--${layout}`}>
        {top5Posting.map((post) => (
           <article
            key={post.id}
            className="hpc-card"
            onClick={() => window.open(`/community/${post.id}`, "_blank")}
          >
            <PostCardMedia mediaType={post.media_type} mediaUrls={JSON.parse(post.media_urls)} />
            <div className="hpc-card-body">
              <p className={`hpc-content  ${ post.media_urls === null && 'hpc-content--onlytext'}`}>{stripMentionsToText(post.content)}</p>
              <div className="hpc-stats">
                <span className="hpc-stat-item">
                  {/* 조회수 */}
                  <svg viewBox="0 0 16 16" fill="none">
                    <path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5S1 8 1 8z" stroke="#bbb" strokeWidth="1.3" />
                    <circle cx="8" cy="8" r="2" stroke="#bbb" strokeWidth="1.3" />
                  </svg>
                  {post.view_count?.toLocaleString() ?? 0}
                </span>
                <span className="hpc-stat-dot">·</span>
                <span className="hpc-stat-item hpc-stat-like" 
                // onClick={(e) => handlePostLike(e, post.id)}
                >
                  {/* 좋아요 */}
                  <svg viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 13.5S2 9.5 2 5.5A3.5 3.5 0 0 1 8 3.2 3.5 3.5 0 0 1 14 5.5c0 4-6 8-6 8z"
                      stroke="#e40000"
                      fill={post.is_liked ? "#e40000" : "#fff"}
                      strokeWidth="1.3"
                    />
                  </svg>
                  <span>{post.like_count ?? 0}</span>
                </span>
                <span className="hpc-stat-dot">·</span>
                <span className="hpc-stat-item">
                  {/* 댓글 */}
                  <svg viewBox="0 0 16 16" fill="none">
                    <path
                      d="M13 8.5c0 3-2.686 5.5-6 5.5a6.4 6.4 0 0 1-3-.75L1.5 14l.75-3A6.4 6.4 0 0 1 2 8.5C2 5.5 4.686 3 8 3s6 2.5 6 5.5z"
                      stroke="#bbb"
                      strokeWidth="1.3"
                    />
                  </svg>
                  {post.comment_count ?? 0}
                </span>
                <span className="hpc-stat-time">{formatTime(post.updated_at)}</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default CommunityComponent;
